import React from 'react'
import Guide from '../user/Guide';

const BuyerGuide = () => {
  const pdfUrl = "/BuyerGuide.pdf";
  return <Guide pdfUrl={pdfUrl} pageTitle="Buyer's" />;
}

export default BuyerGuide